angular.module('gym.profile').controller('EditProfileController', ["$scope", "$rootScope", "$stateParams", "$location", "$http", "$timeout", "$modal", "$q", "ReactModal", "loadingAnimation", "EmploymentService", "MessageService", "GTMService", "AdminUserService", "MasqueradingService", "flash", "profile", function($scope, $rootScope, $stateParams, $location, $http, $timeout, $modal, $q, ReactModal, loadingAnimation, EmploymentService, MessageService, GTMService, AdminUserService, MasqueradingService, flash, profile) {
  var displayMultisiteChangeErrorMessage, gym, isAccountOwner, isEmailNotVerified, saveImage, saveProfile;
  gym = $rootScope.gym;
  $scope.currentTab = $stateParams.tab || 'profile';
  $scope.profile = profile;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.adminHasPermission = AdminUserService.has;
  $scope.imageData = {};
  $scope.countryTimezonesData = profile.country_timezones_data;
  $scope.currentUser = window.currentUser;
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  $scope.phoneNumberPresent = $scope.profile.phone_number;
  $scope.isPhoneNumberVerified = $scope.profile.phone_number_verified;
  $scope.shouldShowVerifiedNumberActions = $scope.currentUser.id === $scope.profile.id && !$scope.isMasquerading;
  $scope.shouldShowRemoveVerifiedNumberAction = $scope.currentUser.id === $scope.profile.id || $scope.isMasquerading || $scope.permissions.manage_users;
  $scope.fetchProfile = function() {
    var params, url;
    url = `/gyms/${gym.id}/profile/edit`;
    params = {
      user_id: $stateParams.userId
    };
    return $http.get(url, {
      params: params
    }).then(function(response) {
      $scope.profile = response.data;
      return $scope.isPhoneNumberVerified = $scope.profile.phone_number_verified;
    });
  };
  $scope.showPhoneNumberVerifiedModal = function() {
    return MessageService.message({
      title: 'This phone number has been verified',
      message: [`The phone number linked to your account (<strong>${$scope.profile.phone_number}</strong>) has been verified.`, "", "Having a verified number linked to your account helps us keep your account secure.", "", "We <strong>strongly recommend</strong> updating Clubworx if you ever lose or change your phone number in future. If this happens, please use the &quot;change&quot; or &quot;remove&quot; links on this page to update your number and ensure your details are correct."],
      bindHtml: true,
      confirmButtonText: 'Close',
      displayCancelButton: false
    });
  };
  $scope.removeVerifiedPhoneNumber = function() {
    return ReactModal.open({
      component: 'RemoveVerifiedPhoneNumberModal',
      props: {
        profileId: $scope.profile.id
      }
    }).then(function(result) {
      if (result != null ? result.success : void 0) {
        if (typeof $scope.fetchProfile === "function") {
          $scope.fetchProfile();
        }
        return $scope.phoneNumberPresent = false;
      }
    });
  };
  $scope.changeVerifiedPhoneNumber = function() {
    var isSsoUser;
    isSsoUser = $scope.profile.ssi_enabled;
    return ReactModal.open({
      component: 'ChangeVerifiedPhoneNumberModal',
      props: {
        profileId: $scope.profile.id,
        defaultCountryCode: $scope.profile.country.toLowerCase(),
        isSocialLogin: isSsoUser
      }
    }).then(function(result) {
      if (result != null ? result.success : void 0) {
        return typeof $scope.fetchProfile === "function" ? $scope.fetchProfile() : void 0;
      }
    });
  };
  $scope.verifyPhoneNumber = function() {
    return ReactModal.open({
      component: 'VerifyPhoneNumberModal',
      props: {
        profileId: $scope.profile.id,
        phoneNumber: $scope.profile.phone_number
      }
    }).then(function(result) {
      if (result != null ? result.success : void 0) {
        return typeof $scope.fetchProfile === "function" ? $scope.fetchProfile() : void 0;
      }
    });
  };
  if ($scope.currentTab === 'availability') {
    GTMService.trackPage('Users - Edit Availability');
  }
  if ($scope.currentTab === 'payroll') {
    GTMService.trackPage('Users - Payrolls');
  }
  $scope.isPayor = window.currentUser.account_owner;
  $scope.isMasquerading = MasqueradingService.isMasquerading();
  $scope.profileTabName = function() {
    if ($scope.isCurrentUser()) {
      return 'Your Profile';
    } else {
      return `${$scope.profile.first_name}'s Profile`;
    }
  };
  $scope.isCurrentUser = function() {
    return profile.id === window.currentUser.id;
  };
  isAccountOwner = window.currentUser.id === gym.payor_id;
  isEmailNotVerified = window.currentUser.email_verification_status === "email_not_verified";
  $scope.isCurrentUserUnverified = isAccountOwner && isEmailNotVerified;
  $scope.openVerificationModal = function() {
    return ReactModal.open({
      component: 'VerifyEmailModal'
    });
  };
  $scope.canManageUser = function() {
    return $scope.isCurrentUser() || $scope.permissions.manage_users;
  };
  $scope.setTab = function(tab) {
    $location.search(angular.extend({}, $location.search(), {
      'tab': tab
    }));
    $scope.currentTab = tab;
    return $scope.open = false;
  };
  $scope.onCountryChanged = function() {
    var country;
    country = $scope.profile.country;
    return $scope.profile.tz = $scope.countryTimezonesData[country].timezones[0].id;
  };
  $scope.selectPhoto = function() {
    angular.element('#contact-photo-input').click();
    return true;
  };
  saveImage = function(image) {
    var params, url;
    url = `/gyms/${$stateParams.gymId}/profile/update_image`;
    params = {
      user: {
        image: image
      },
      user_id: $scope.profile.id
    };
    return $http.post(url, params).then(function(response) {
      flash.success = "Updated successfully";
      $scope.imageData.imagePreview = void 0;
      return $scope.profile.image_url = response.data.image_url;
    });
  };
  $scope.$watch('imageData.file', function(file) {
    var dataUrlReader;
    if (file != null ? file.size : void 0) {
      if (file.size > 5000000) {
        flash.error = 'Image size must be 5MB or lower';
        return;
      }
      dataUrlReader = new window.FileReader();
      dataUrlReader.readAsDataURL(file);
      return dataUrlReader.onloadend = function() {
        return $timeout(function() {
          var image;
          $scope.imageData.imagePreview = dataUrlReader.result;
          $scope.profile.image_url = void 0;
          image = dataUrlReader.result.replace(/^data:image\/\w*;base64,/, '');
          return saveImage(image);
        });
      };
    }
  });
  displayMultisiteChangeErrorMessage = function() {
    return $modal.open({
      template: require('templates/gyms/profile/multisite_change_error_message.html.slim'),
      controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
  };
  saveProfile = function(password) {
    var deferred, params, url;
    deferred = $q.defer();
    url = `/gyms/${$stateParams.gymId}/profile`;
    $scope.profile.password = void 0;
    $scope.profile.password_confirmation = void 0;
    loadingAnimation.show();
    params = {
      user: $scope.profile,
      user_id: profile.id,
      user_password: password
    };
    $http.put(url, params).then(function(response) {
      flash.success = "Updated successfully";
      loadingAnimation.hide();
      $scope.profile = response.data;
      $scope.phoneNumberPresent = response.data.phone_number;
      return deferred.resolve();
    }, function(response) {
      loadingAnimation.hide();
      if (response.data.errors) {
        $scope.profile.errors = response.data.errors;
        if (response.data.errors.show_multisite_change_error_message) {
          displayMultisiteChangeErrorMessage();
        } else {
          flash.error = "Save failed. Please fix the errors below";
        }
        return deferred.resolve();
      } else {
        return deferred.reject();
      }
    });
    return deferred.promise;
  };
  $scope.changeEmail = function() {
    return ReactModal.open({
      component: 'ChangeEmailModal',
      props: {
        profile: $scope.profile
      }
    }).then(function(response) {
      return $scope.profile.email = response.email;
    });
  };
  $scope.saveProfile = function() {
    var isCurrentUserEditing, isMasqueradingActiveGym, isSsoUser, requiresConfirmation;
    isSsoUser = $scope.currentUser.ssi_enabled;
    isCurrentUserEditing = $scope.isCurrentUser() && !MasqueradingService.isMasquerading();
    isMasqueradingActiveGym = MasqueradingService.isMasquerading() && gym.active;
    requiresConfirmation = isCurrentUserEditing || isMasqueradingActiveGym;
    if (isSsoUser && requiresConfirmation) {
      return ReactModal.open({
        component: 'ManageMfaModal',
        props: {
          mode: 'save_profile',
          isSocialLogin: isSsoUser,
          onConfirm: function(userVerificationId, code) {
            var params, url;
            url = `/gyms/${$stateParams.gymId}/profile`;
            $scope.profile.password = void 0;
            $scope.profile.password_confirmation = void 0;
            loadingAnimation.show();
            params = {
              user: $scope.profile,
              user_id: $scope.profile.id,
              code: code,
              user_verification_id: userVerificationId
            };
            return $http.put(url, params).then(function(response) {
              flash.success = "Updated successfully";
              loadingAnimation.hide();
              $scope.profile = response.data;
              return $scope.phoneNumberPresent = response.data.phone_number;
            }, function(response) {
              loadingAnimation.hide();
              if (response.data.errors) {
                $scope.profile.errors = response.data.errors;
                if (response.data.errors.show_multisite_change_error_message) {
                  displayMultisiteChangeErrorMessage();
                } else {
                  flash.error = "Save failed. Please fix the errors below";
                }
              }
              throw response;
            });
          }
        }
      });
    } else if (requiresConfirmation) {
      return $modal.open({
        template: require('templates/gyms/profile/confirm_password_modal.html.slim'),
        controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
          $scope.params = {};
          $scope.submit = function() {
            if ($scope.isLoading || !$scope.params.password) {
              return;
            }
            $scope.isLoading = true;
            return saveProfile($scope.params.password).then(function() {
              return $modalInstance.close();
            }, function() {
              $scope.isLoading = false;
              return $scope.errors = {
                password: ['Incorrect password provided']
              };
            });
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
    } else {
      return saveProfile();
    }
  };
  $scope.approveSocialLoginConnection = function(socialUrl) {
    var url;
    url = `/gyms/${$stateParams.gymId}/profile/check_password_for_omniauth_link`;
    return $modal.open({
      template: require('templates/gyms/profile/authenticate_social_login_modal.html.slim'),
      controller: ["$scope", "$modalInstance", "$timeout", "$http", function($scope, $modalInstance, $timeout, $http) {
        $scope.params = {};
        $scope.isLoading = false;
        $scope.errors = {};
        $scope.submit = function() {
          if ($scope.isLoading || !$scope.params.password) {
            return;
          }
          $scope.isLoading = true;
          return $http.post(url, {
            user_password: $scope.params.password
          }).then(function() {
            var link;
            link = document.createElement('a');
            link.setAttribute('data-method', 'POST');
            link.setAttribute('href', socialUrl);
            link.setAttribute('target', '_self');
            document.body.appendChild(link);
            return link.click();
          }).catch(function(error) {
            $scope.isLoading = false;
            return $scope.errors = {
              password: [error.data.error_message]
            };
          });
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
  };
  $scope.savePassword = function() {
    var params, url;
    if ($scope.profile.password !== $scope.profile.password_confirmation) {
      $scope.profile.errors = {
        password_confirmation: ['Passwords do not match']
      };
      return;
    }
    url = `/gyms/${$stateParams.gymId}/profile/update_password`;
    loadingAnimation.show();
    params = {
      user: $scope.profile,
      user_id: profile.id
    };
    return $http.post(url, params).then(function(response) {
      flash.success = "Updated successfully";
      $scope.profile = response.data;
      return loadingAnimation.hide();
    }, function(response) {
      loadingAnimation.hide();
      $scope.profile.errors = response.data.errors;
      return flash.error = "Save failed. Please fix the errors below";
    });
  };
  return $scope.isPasswordValid = function() {
    return $scope.profile.password && $scope.profile.password_confirmation;
  };
}]);
